import { CartLinesUpdateEvent } from '@shopify/events';

// Scoped to this product section; safe to reconnect in the Shopify editor.
class HibikuraNano extends HTMLElement {
  connectedCallback() {
    if(this.initialized) return;
    this.initialized=true; this.abort=new AbortController();
    this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
    this.form=this.querySelector('.nng-form'); this.activeSlide=0;
    this.on('click',e=>this.click(e)); this.on('change',e=>this.change(e));
    this.form.addEventListener('submit',e=>{e.preventDefault();this.purchase(false);},{signal:this.abort.signal});
    this.mediaList=this.querySelector('.nng-media-list');
    this.mediaList.addEventListener('scroll',()=>{
      if(matchMedia('(max-width:749px)').matches){const index=Math.round(this.mediaList.scrollLeft/this.mediaList.clientWidth);this.markSlide(index);}
    },{passive:true,signal:this.abort.signal});
    const scheduleLayout=()=>{
      cancelAnimationFrame(this.galleryLayoutFrame);
      this.galleryLayoutFrame=requestAnimationFrame(()=>this.layoutGallery());
    };
    this.mediaList.addEventListener('load',scheduleLayout,{capture:true,signal:this.abort.signal});
    window.addEventListener('resize',scheduleLayout,{signal:this.abort.signal});
    if(typeof ResizeObserver!=='undefined'){
      this.galleryResizeObserver=new ResizeObserver(scheduleLayout);
      this.galleryResizeObserver.observe(this.mediaList);
      this.querySelectorAll('.nng-media').forEach(media=>{
        if(media.firstElementChild)this.galleryResizeObserver.observe(media.firstElementChild);
      });
    }
    this.layoutGallery();
    // Muted, inline video loops start when visible, including on returning to
    // the video slide. Pause off-screen media to avoid unnecessary playback.
    if(typeof IntersectionObserver!=='undefined'){
      this.galleryVideoObserver=new IntersectionObserver(entries=>{
        entries.forEach(({target,isIntersecting})=>{
          if(isIntersecting){target.muted=true;target.play()?.catch(()=>{});}
          else target.pause();
        });
      },{threshold:0.15});
      this.querySelectorAll('.nng-gallery-video').forEach(video=>this.galleryVideoObserver.observe(video));
    }
    this.reviews=[...this.querySelectorAll('[data-review]')];
    if(this.dataset.designMode!=='true' && this.reviews.length>5){
      const nav=this.querySelector('[data-review-pages]');
      for(let i=0;i<Math.ceil(this.reviews.length/5);i++){const b=document.createElement('button');b.type='button';b.dataset.reviewPage=i;b.textContent=String(i+1);b.setAttribute('aria-label',`レビュー ${i+1}ページ`);nav.append(b);} this.reviewPage(0);
    }
    this.updatePrices(); this.timer();
    document.addEventListener('shopify:block:select',e=>{if(!this.contains(e.target))return;const faq=e.target.closest('details');if(faq)faq.open=true;},{signal:this.abort.signal});
  }
  disconnectedCallback(){this.abort?.abort();this.galleryVideoObserver?.disconnect();this.galleryResizeObserver?.disconnect();cancelAnimationFrame(this.galleryLayoutFrame);clearInterval(this.interval);this.initialized=false;}
  layoutGallery(){
    const masonry=this.dataset.gallery==='stacked'&&!matchMedia('(max-width:749px)').matches;
    const media=[...this.querySelectorAll('.nng-media')];
    this.mediaList.classList.toggle('is-masonry',masonry);
    if(!masonry){
      this.mediaList.style.removeProperty('height');
      media.forEach(item=>{item.style.removeProperty('left');item.style.removeProperty('top');});
      return;
    }
    const gap=8,width=this.mediaList.clientWidth,columnWidth=(width-gap)/2;
    if(width<=0)return;
    const bottoms=[0,0];
    media.forEach(item=>{
      const full=item.classList.contains('nng-media--full');
      const column=bottoms[0]<=bottoms[1]?0:1;
      const top=full?Math.max(...bottoms):bottoms[column];
      const left=full?0:column*(columnWidth+gap);
      item.style.left=`${left}px`;item.style.top=`${top}px`;
      const bottom=top+item.getBoundingClientRect().height+gap;
      if(full)bottoms.fill(bottom);else bottoms[column]=bottom;
    });
    this.mediaList.style.height=`${Math.max(0,Math.max(...bottoms)-gap)}px`;
  }
  on(event,listener){this.addEventListener(event,listener,{signal:this.abort.signal});}
  money(cents){return new Intl.NumberFormat('ja-JP',{style:'currency',currency:'JPY',maximumFractionDigits:0}).format(cents/100);}
  variant(id){return this.variants.find(v=>String(v.id)===String(id));}
  current(){return this.variant(this.form.querySelector('input[name=id]').value);}
  click(e){
    const slide=e.target.closest('[data-slide]');if(slide)this.goSlide(this.activeSlide+Number(slide.dataset.slide));
    const thumb=e.target.closest('[data-slide-to]');if(thumb)this.goSlide(Number(thumb.dataset.slideTo));
    const zoom=e.target.closest('[data-zoom]');if(zoom){const img=zoom.querySelector('img');const modal=this.querySelector('.nng-modal');const target=modal.querySelector('img');target.src=img.src;target.alt=img.alt;modal.showModal();}
    if(e.target.closest('[data-close]'))this.querySelector('.nng-modal').close();
    if(e.target===this.querySelector('.nng-modal'))this.querySelector('.nng-modal').close();
    const page=e.target.closest('[data-review-page]');if(page){this.reviewPage(Number(page.dataset.reviewPage));this.querySelector('.nng-review-header')?.scrollIntoView({behavior:'smooth',block:'start'});}
    if(e.target.closest('[data-buy]'))this.purchase(true);
  }
  change(e){
    if(e.target.matches('.nng-colors input')){
      const id=e.target.value;this.form.querySelector('input[name=id]').value=id;
      this.querySelectorAll('[data-unit="1"]').forEach(s=>s.value=id);
      const url=new URL(location.href);url.searchParams.set('variant',id);history.replaceState({},'',url);
    }
    if(e.target.matches('.nng-bundle input[type=radio]')){
      this.querySelectorAll('.nng-bundle').forEach(b=>b.classList.toggle('is-selected',b.dataset.bundle===e.target.value));
    }
    if(e.target.matches('[data-unit]') && e.target.dataset.unit==='1'){
      const id=e.target.value;this.form.querySelector('input[name=id]').value=id;
      this.querySelectorAll('[data-unit="1"]').forEach(s=>s.value=id);
      const input=this.querySelector(`.nng-colors input[value="${id}"]`);if(input)input.checked=true;
      const url=new URL(location.href);url.searchParams.set('variant',id);history.replaceState({},'',url);
    }
    this.updatePrices();
  }
  items(){
    const selected=this.querySelector('.nng-bundle.is-selected');
    const selectors=selected?[...selected.querySelectorAll('[data-unit]')]:[];
    const ids=selectors.length?selectors.map(s=>s.value):Array(Number(selected?.dataset.bundle||1)).fill(String(this.current().id));
    const grouped=new Map();ids.forEach(id=>grouped.set(id,(grouped.get(id)||0)+1));
    return [...grouped].map(([id,quantity])=>({id:Number(id),quantity}));
  }
  updatePrices(){
    const variant=this.current();if(!variant)return;
    this.querySelector('[data-price]').textContent=this.money(variant.price);
    this.querySelector('[data-compare]').textContent=variant.compare_at_price>variant.price?this.money(variant.compare_at_price):'';
    this.querySelector('[data-sale]').textContent=variant.compare_at_price>variant.price?`${Math.round((1-variant.price/variant.compare_at_price)*100)}% OFF`:'';
    this.querySelectorAll('.nng-bundle').forEach(bundle=>{
      const selectors=[...bundle.querySelectorAll('[data-unit]')];
      const subtotal=selectors.length?selectors.reduce((sum,s)=>sum+(this.variant(s.value)?.price||0),0):variant.price*Number(bundle.dataset.bundle);
      const discounted=Math.round(subtotal*(100-Number(bundle.dataset.discount))/100);
      bundle.querySelector('[data-bundle-price]').textContent=this.money(discounted);
      const compare=bundle.querySelector('[data-bundle-compare]');if(compare)compare.textContent=this.money(subtotal);
    });
    const available=this.items().every(i=>this.variant(i.id)?.available);
    const add=this.querySelector('[data-add]');add.disabled=!available;add.textContent=available?add.dataset.label:add.dataset.soldLabel;
    const buy=this.querySelector('[data-buy]');if(buy)buy.disabled=!available;
  }
  async purchase(checkout){
    if(this.busy || this.querySelector('[data-add]').disabled)return;
    this.busy=true;const error=this.querySelector('[data-error]');error.hidden=true;
    const buttons=[this.querySelector('[data-add]'),this.querySelector('[data-buy]')].filter(Boolean);buttons.forEach(b=>b.disabled=true);
    try{
      const root=window.Shopify?.routes?.root||'/';
      const items=this.items();
      const sections=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(component=>component.dataset.sectionId))].slice(0,5);
      const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,...(!checkout&&{sections:sections.join(','),sections_url:location.pathname})})});
      const result=await response.json();if(!response.ok)throw new Error(result.description||error.dataset.fallback);
      if(checkout){location.assign(`${root}checkout`);return;}
      // Use Horizon's native cart event so the drawer, totals and header count
      // all refresh from the same successful add, without leaving the product.
      const cartResponse=await fetch(`${root}cart.js`,{headers:{Accept:'application/json'}});
      if(!cartResponse.ok)throw new Error(error.dataset.fallback);
      const cart=await cartResponse.json();
      this.dispatchEvent(new CartLinesUpdateEvent({
        action:'add',context:'product',
        lines:items.map(item=>({merchandiseId:String(item.id),quantity:item.quantity})),
        promise:Promise.resolve({
          cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail:{items:cart.items,itemCount:cart.item_count,sections:result.sections,source:'hibikura-nano',sourceId:this.dataset.section,didError:false},
        }),
      }));
    }catch(e){error.textContent=e.message||error.dataset.fallback;error.hidden=false;}
    finally{this.busy=false;this.updatePrices();}
  }
  markSlide(index){
    this.activeSlide=index;this.querySelectorAll('.nng-media').forEach((m,i)=>m.classList.toggle('is-active',i===index));
    this.querySelectorAll('[data-slide-to]').forEach((b,i)=>{if(i===index)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current');});
  }
  goSlide(index){
    const count=this.querySelectorAll('.nng-media').length;if(!count)return;index=(index+count)%count;
    this.querySelectorAll('video:not(.nng-gallery-video)').forEach(v=>v.pause());this.markSlide(index);
    const media=this.querySelectorAll('.nng-media')[index];
    if(matchMedia('(max-width:749px)').matches)this.mediaList.scrollTo({left:index*this.mediaList.clientWidth,behavior:'smooth'});
    else if(this.dataset.gallery==='stacked'){
      const gallery=this.querySelector('.nng-gallery');
      gallery.scrollTo({top:gallery.scrollTop+media.getBoundingClientRect().top-gallery.getBoundingClientRect().top,behavior:'smooth'});
    }
    this.querySelector(`[data-slide-to="${index}"]`)?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
  }
  reviewPage(index){this.reviews.forEach((r,i)=>r.hidden=i<index*5||i>=(index+1)*5);this.querySelectorAll('[data-review-page]').forEach(b=>{if(Number(b.dataset.reviewPage)===index)b.setAttribute('aria-current','page');else b.removeAttribute('aria-current');});}
  timer(){
    const element=this.querySelector('[data-deadline]');if(!element)return;const deadline=Date.parse(element.dataset.deadline);if(!Number.isFinite(deadline))return;
    const tick=()=>{const remaining=deadline-Date.now();element.hidden=remaining<=0;if(remaining<=0){clearInterval(this.interval);return;}const seconds=Math.floor(remaining/1000);element.querySelector('[data-countdown]').textContent=`${Math.floor(seconds/86400)}日 ${String(Math.floor(seconds/3600)%24).padStart(2,'0')}:${String(Math.floor(seconds/60)%60).padStart(2,'0')}:${String(seconds%60).padStart(2,'0')}`;};tick();this.interval=setInterval(tick,1000);
  }
}
if(!customElements.get('hibikura-nano'))customElements.define('hibikura-nano',HibikuraNano);
